// import lazyLoading from '../lazyLoading';

export default {
  name: 'report_list',
  caption: 'Rapor Modülü',
  wdm16_id: '',
  icon: 'icon-pencil',
  path: '/report-module',
  // component: lazyLoading('patient/index'),
  required: ['logined'],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};